'use client';

import { jsx } from "react/jsx-runtime";
import { ButtonGroup } from "../ButtonGroup/ButtonGroup.js";
import { classNames } from "../../utils/styles/classNames.js";
import { mainBg, buttons } from "./InlineNotification.css.js";
function ActionButtons({ actions, variant }) {
  if (actions.length === 0) return null;
  return /* @__PURE__ */ jsx("div", { className: classNames(buttons, mainBg[variant]), children: /* @__PURE__ */ jsx(ButtonGroup, { buttons: actions, size: "sm" }) });
}
export {
  ActionButtons
};
